<template>
  <v-dialog v-model="dialogproduct" persistent max-width="600">
    <v-card>
      <v-card-title class="heading primary white--text">{{ isnewproduk ? 'Tambah Produk' : 'Edit Produk'
        }}</v-card-title>
      <v-card-text class="mt-4">
        <v-row>
          <v-col cols="6">
            <v-select label="Category" item-text="name" item-value="id" v-model="selectedproduct.productcategoryid"
              :items="categories"></v-select>
          </v-col>
          <v-col cols="6">
            <v-autocomplete label="Brand" item-text="brandname" item-value="id" v-model="selectedproduct.brandid"
              :items="brandselect"></v-autocomplete>
          </v-col>
        </v-row>
        <v-text-field label="Nama" v-model="selectedproduct.productname"></v-text-field>
        <v-text-field label="Deskripsi" v-model="selectedproduct.description"></v-text-field>
        <v-text-field label="Kode" v-model="selectedproduct.productcode"></v-text-field>
        <v-row>
          <v-col cols="6">
            <v-select label="Jenis Produk" item-text="text" item-value="value" v-model="selectedproduct.producttype" :items="jenisproduk"></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field label="Denom" v-model="selectedproduct.denom"></v-text-field>
          </v-col>
        </v-row>
        <v-switch v-model="statusSlider" inset label="Aktif">Aktif</v-switch>
      </v-card-text>
      <v-divider />
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn elevation="0" color="red darken-1" dark @click.native="setdialogproduct(false)">Batal</v-btn>
        <v-btn elevation="0" color="primary darken-1" @click.native="simpan">Simpan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogProduct',
  data: () => ({
    jenisproduk: [
      { text: 'Pulsa/Prepaid', value: 0 },
      { text: 'PPOB', value: 1 },
      { text: 'Open Denom', value: 2 }
    ]
  }),
  computed: {
    ...mapState('AdminProducts', ['dialogproduct', 'selectedproduct', 'brandselect', 'categories', 'isnewproduk']),
    statusSlider: {
      get () {
        return this.selectedproduct.status === 1
      },
      set (val) {
        if (val) {
          this.selectedproduct.status = 1
        } else {
          this.selectedproduct.status = 0
        }
      }
    }
  },
  methods: {
    ...mapActions('AdminProducts', ['setdialogproduct', 'editProduk', 'tambahProduk']),
    simpan () {
      if (this.isnewproduk) {
        this.tambahProduk(this.selectedproduct)
      } else {
        this.editProduk(this.selectedproduct)
      }
    }
  }
}
</script>

<style scoped></style>
